import { useCallback, useRef, useState } from 'react'
import {
  clampPlaybackVolume,
  DEFAULT_PLAYBACK_VOLUME,
  parseStoredPlaybackVolume,
  PLAYBACK_VOLUME_STORAGE_KEY,
} from '../lib/playbackPreferences'

function loadInitialVolume(): number {
  try {
    return parseStoredPlaybackVolume(localStorage.getItem(PLAYBACK_VOLUME_STORAGE_KEY))
  } catch {
    return DEFAULT_PLAYBACK_VOLUME
  }
}

export function usePlaybackVolume() {
  const [volume, setVolumeState] = useState(loadInitialVolume)
  const lastAudibleVolume = useRef(volume > 0 ? volume : DEFAULT_PLAYBACK_VOLUME)

  const setVolume = useCallback((nextValue: number) => {
    const next = clampPlaybackVolume(nextValue)
    if (next > 0) lastAudibleVolume.current = next
    setVolumeState(next)
    try {
      localStorage.setItem(PLAYBACK_VOLUME_STORAGE_KEY, String(next))
    } catch {
      // 사생활 보호 모드 등 저장소를 쓸 수 없는 환경에서도 재생은 계속합니다.
    }
  }, [])

  const toggleMute = useCallback(() => {
    setVolume(volume === 0 ? lastAudibleVolume.current : 0)
  }, [setVolume, volume])

  return {
    muted: volume === 0,
    setVolume,
    toggleMute,
    volume,
  }
}
